import React, { Component } from "react";
import Formsy from "formsy-react";
import { TextInput } from "./TextInput";
import { Button, Row, Col } from "reactstrap";
import { MdSearch } from "react-icons/md";
import { Spinner } from "../Spinner";

class TableSearch extends Component {
  state = {
    canSubmit: false,
    submitting: false
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  handleFormChange = data => {
    if (!data[this.props.searchParam]) {
      this.props.filterData(data);
    }
  };

  handleSubmit = data => {
    if (data[this.props.searchParam]) {
      this.props.filterData(data);
    }
  };

  render() {
    const { canSubmit, submitting } = this.state;
    const { searchParam, placeholder } = this.props;
    return (
      <Formsy
        ref="searchform"
        onChange={this.handleFormChange}
        onValidSubmit={this.handleSubmit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
        noValidate
      >
        <Row noGutters>
          <Col xs="10">
            <TextInput
              name={searchParam}
              type="search"
              size="sm"
              disabled={submitting}
              placeholder={placeholder}
            />
          </Col>
          <Col xs="2">
            <Button
              type="submit"
              block
              size="sm"
              color="primary"
              disabled={!canSubmit || submitting}
            >
              {submitting ? <Spinner size="sm" /> : <MdSearch size={20} />}
            </Button>
          </Col>
        </Row>
      </Formsy>
    );
  }
}

export default TableSearch;
